import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { Contractdate } from './contractdate.model';
import { ContractdateService } from './contractdate.service';

@Component({
    selector: 'jhi-contractdate-detail',
    templateUrl: './contractdate-detail.component.html'
})
export class ContractdateDetailComponent implements OnInit, OnDestroy {

    contractdate: Contractdate;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private contractdateService: ContractdateService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['contractdate']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInContractdates();
    }

    load(id) {
        this.contractdateService.find(id).subscribe((contractdate) => {
            this.contractdate = contractdate;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInContractdates() {
        this.eventSubscriber = this.eventManager.subscribe('contractdateListModification', (response) => this.load(this.contractdate.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contractdate/contractdate-detail.component.ts